var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.568,
    height: 41.568,
    viewBox: "0 0 41.568 41.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(10.053 10.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M893.973,410.358a1.245,1.245,0,1,1-1.245-1.245A1.245,1.245,0,0,1,893.973,410.358Zm-1.55,5.581a5.23,5.23,0,1,1-5.23-5.23A5.236,5.236,0,0,1,892.423,415.939Zm-1.88,0a3.35,3.35,0,1,0-3.35,3.35A3.354,3.354,0,0,0,890.544,415.939Zm7.235-4.2a6.379,6.379,0,0,0-6.379-6.379h-8.7a6.379,6.379,0,0,0-6.379,6.379v8.705a6.379,6.379,0,0,0,6.379,6.379h8.7a6.379,6.379,0,0,0,6.379-6.379Zm-2.094,8.609a4.381,4.381,0,0,1-4.381,4.381h-8.512a4.381,4.381,0,0,1-4.381-4.381v-8.513a4.381,4.381,0,0,1,4.381-4.381H891.3a4.381,4.381,0,0,1,4.381,4.381Z",
    transform: "translate(-876.316 -405.359)",
    fill: "#17447e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M878.977,387.236a20.784,20.784,0,1,0,20.784,20.784A20.807,20.807,0,0,0,878.977,387.236Zm0,38.9A18.118,18.118,0,1,1,897.1,408.02,18.139,18.139,0,0,1,878.977,426.138Z",
    transform: "translate(-858.193 -387.236)",
    fill: "#17447e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.1af4d54dbae0a237e800f57b017dce2d.svg";
export { ForwardRef as ReactComponent };